import { render, staticRenderFns } from "./saasFullUpgrade__form.vue?vue&type=template&id=4b24847c"
import script from "./saasFullUpgrade__form.vue?vue&type=script&lang=js"
export * from "./saasFullUpgrade__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports